import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import { H6, P1, P2, Modal } from 'pfm-ui-components';
import NotificationSvg from '../../../assets/icons/notification-icon.svg';
import { HorizontalLineWithinCard, HorizontalLine } from '../HorizontalLine';
import { NOTIFICATION, NO_NOTIFICATION_MESSAGE } from '../../../constants/Notification';
import { pxToRem } from '../../../styles/utils';

interface NotificationModalProps {
  notifications: Array<string>; // array of notification objects
  onClose: Function;
}

export default function NotificationModal(props: NotificationModalProps) {
  const { notifications, onClose } = props;

  const handleKFintechClick =()=>{
    window.open(`https://mfs.kfintech.com/investor/General/NCTNomineeUpdation`, '_blank')
  }
  const handleCAMSClick =()=>{
    window.open(`https://digital.camsonline.com/changeofnomination`, '_blank')
  }

  const defaultNotification = 'As per thand update the same in ITD records'
  const NotificationHeader = () => (
    <NotificationHeaderWrapper>
      <NotificationIcon />

      <NotificationHeaderTitle>{NOTIFICATION}</NotificationHeaderTitle>
      <HorizontalLineWithinCard />
    </NotificationHeaderWrapper>
  );

  return (
    <StyledModal
      id="notification"
      onClose={() => onClose()}
      HeaderComponent={NotificationHeader()}
      className="notification-modal"
      contentClassname="notification-modal-content"
    >
      <Container2 >
        <NotificationMessageContainer>
        <NotificationMessage>
              To view / update your existing Mutual Fund folios nomination, visit
                <TextHighlight2 onClick={() => handleKFintechClick()}> KFintech </TextHighlight2>
                or
                <TextHighlight2 onClick={() => handleCAMSClick()}> CAMS </TextHighlight2>
                website
              </NotificationMessage>
          {/* <NotificationMessage dangerouslySetInnerHTML={{ __html: defaultNotification }} /> */}
        </NotificationMessageContainer>
        <HorizontalLineWithinCard />
      </Container2>
      <NotificationMessageWrapper>
        {notifications && notifications.length > 0 ? (
          notifications.map(
            (notification, index) =>
              notification?.length > 0 && (
                <Container key={index}>
                  <NotificationMessageContainer>
                    {/* <NotificationMessageTitle>{notification.heading}</NotificationMessageTitle> */}
                    <NotificationMessage dangerouslySetInnerHTML={{ __html: notification }} />
                  </NotificationMessageContainer>
                  {index !== notifications.length - 1 && <HorizontalLineWithinCard />}
                </Container>
              )
          )
        ) : (
          <NoNotificationMessageWrapper>{NO_NOTIFICATION_MESSAGE}</NoNotificationMessageWrapper>
        )}
      </NotificationMessageWrapper>
    </StyledModal>
  );
}

const StyledModal = styled(Modal)`
  &.notification-modal-body {
    padding-top: ${pxToRem(8)};
    padding-bottom: ${pxToRem(8)};
  }
  .notification-modal-content {
    ${up('md')} {
      margin: 0 auto;
      left: 0;
      top: 50%;
    }
  }
`;

const NotificationMessageWrapper = styled.article`
  max-height: ${pxToRem(356)};
  ${up('md')} {
    max-height: ${pxToRem(432)};
  }
`;

const Container = styled.article`
  padding: ${pxToRem(8)} 0;
`;

const Container2 = styled.article`
  padding: ${pxToRem(8)} 0;
  position: sticky;
  z-index: 100;
  background-color: white;
  top:-10px;
`;

const TextHighlight2 = styled.span`
  text-decoration:underline;
  color: ${(props) => props.theme.palette.burgundy1};
  cursor: pointer;
`;

const NotificationIcon = styled(NotificationSvg)`
  width: ${pxToRem(36)};
  height: ${pxToRem(36)};
  ${up('md')} {
    width: ${pxToRem(46)};
    height: ${pxToRem(46)};
  }
`;

const NotificationMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 8px;
  ${up('md')} {
    padding: ${pxToRem(8)} 0;
  }
`;
const NotificationMessageTitle = styled(H6)`
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(17)};
  margin-block-end: 0;
  margin-block-start: 0;
  ${up('md')} {
    font-size: ${pxToRem(16)};
    /* line-height: ${pxToRem(19)}; */
  }
`;
const NotificationMessage = styled(P1)`
  padding: 0;
  margin-block-end: 0;
  margin-block-start: 0;
  margin-top: ${pxToRem(-8)};
  margin-bottom: ${pxToRem(6)};
  font-weight: bolder;
  ${up('md')} {
    width: 100%;
  }
`;

const NotificationHeaderWrapper = styled.article`
  width: 75%;
  display: flex;
  justify-content: flex-start;
`;

const NotificationHeaderTitle = styled(P1)`
  font-weight: bold;
  font-size: ${pxToRem(16)};
  margin-left: ${pxToRem(8)};
  padding-top: ${pxToRem(8)};
  line-height: ${pxToRem(19)};
  color: #4a4a4a;
  ${up('md')} {
    padding: ${pxToRem(12)} 0 0 ${pxToRem(8)};
    font-size: ${pxToRem(18)};
    line-height: ${pxToRem(22)};
  }
`;

const StyledHorizontalLine = styled(HorizontalLineWithinCard)`
  margin: ${pxToRem(16)} 0;
  ${up('md')} {
    padding: ${pxToRem(12)} 0;
  }
`;

const NoNotificationMessageWrapper = styled(P1)`
  text-align: center;
  padding: ${pxToRem(12)} 0;
`;
